import React, { useState, useEffect } from "react";
import { getVimeoOembed } from "../../utils/vimeo";
import Image from "../../components/image";
import QuotationMark from "../../images/icons/quotation.inline.svg";

const InternshipVideoCard = ({
  imgSrc,
  imgAlt,
  date,
  active,
  title,
  type = "video",
  sourceUrl,
  featVideos
}) => {
  const featuredImage = imgSrc;
  const [useVideo, setVideo] = useState("");

  useEffect(() => {
    let vimeoId = featVideos?.slice(featVideos.lastIndexOf("/") + 1);

    if (vimeoId) {
      getVimeoOembed(vimeoId)
        .then((result) => {
          return setVideo(result);
        })
        .catch((err) => console.error("Vimeo video error :: ", err));
    }
  }, [featVideos]);
  return (
    <div className="relative rounded-xs bg-yellow-lighter dark:bg-gray-standard mb-8">
      <div
        className={`rounded-xs overflow-hidden ${
          title ? "dark:shadow-md" : "shadow-xl"
        }`}
      >
        <div
          className={`relative h-full ${
            active
              ? "before:hidden md:before:block before:absolute before:w-full before:h-full before:top-0 before:right-0 before:border-5 before:border-white/20"
              : ""
          }`}
        >
          {useVideo ? (
            <>
              <div
                className="w-full h-full object-cover"
                dangerouslySetInnerHTML={{ __html: useVideo.html }}
              />
            </>
          ) : (
            <Image
              imageAlt={title}
              image={featuredImage}
              imageClass="w-full h-full object-cover"
              sourceUrl={sourceUrl}
            />
          )}
        </div>
      </div>

      {title && type === "quote" && (
        <div
          className={`absolute flex left-0 ${
            active ? "bottom-9" : "w-full bottom-9"
          }`}
        >
          <div
            className={`bg-yellow-standard dark:bg-gray-darker ${
              active ? "p-4 md:p-5" : "p-2 md:p-3"
            }`}
          >
            <QuotationMark className="w-4 h-4 md:w-5 md:h-5 fill-white" />
          </div>
          <p
            className={`flex items-center text-black-lighter dark:text-white bg-white dark:bg-gray-standard ${
              active
                ? "font-bold text-[22px] px-7 rounded-r-[5px]"
                : "font-semibold text-mob md:text-sm py-1 md:py-0 px-2 w-full"
            }`}
          >
            {title}
          </p>
        </div>
      )}
    </div>
  );
};

export default InternshipVideoCard;
